class GridView extends HTMLElement {
  constructor() {
    super();
    this.productGrid = document.querySelector(
      ".product-grid-container"
    );
    this.querySelectorAll(".button--grid-view").forEach((button) => {
      button.addEventListener("click", this.changeLayoutGrid.bind(this));
    });
  }

  changeLayoutGrid(event) {
    const gridView = event.currentTarget.dataset.grid;
    this.querySelectorAll(".button--grid-view").forEach((button) => {
      button.classList.add("cursor-pointer");
      button.classList.remove("active");
    });

    event.currentTarget.classList.remove("cursor-pointer");
    event.currentTarget.classList.add("active");

    if (document.startViewTransition) {
      let productItem = this.productGrid.querySelectorAll(".product-item ");
      productItem.forEach((product) => {
        if (product && product.dataset && product.dataset.productId) {
          product.style.setProperty(
            "view-transition-name",
            `product-card-${product.dataset.productId}`
          );
        }
      });

      document
        .startViewTransition(() => {
          this.productGrid.setAttribute("data-view", gridView);
        })
        .finished.finally(() => {
          productItem.forEach((product) => {
            if (product) product.style.removeProperty("view-transition-name");
          });
        });
    } else {
      this.productGrid.setAttribute("data-view", gridView);
    }
  }
}
customElements.define("grid-view", GridView);